import { Link } from 'react-router-dom';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';

export default function Navbar() {
  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className="fixed top-0 left-0 right-0 z-50 bg-slate-900/80 backdrop-blur-md border-b border-purple-500/20"
    >
      <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2">
          <Clock className="w-8 h-8 text-purple-400" />
          <span className="text-2xl font-bold text-gradient">DejaPortal</span>
        </Link>

        {/* Navigation Links */}
        <div className="hidden md:flex items-center gap-6">
          <Link to="/" className="text-gray-300 hover:text-purple-400 transition-colors">
            Home
          </Link>
          <Link to="/nodes" className="text-gray-300 hover:text-purple-400 transition-colors">
            Nodes
          </Link>
          <Link to="/whitepaper" className="text-gray-300 hover:text-purple-400 transition-colors">
            Whitepaper
          </Link>
          <Link to="/crowdfund" className="text-gray-300 hover:text-purple-400 transition-colors">
            Crowdfund
          </Link>
          <Link to="/mint" className="text-gray-300 hover:text-purple-400 transition-colors">
            Mint Portal
          </Link>
        </div>

        {/* Connect Wallet Button */}
        <ConnectButton />
      </div>
    </motion.nav>
  );
}
